import { PageKey } from '@core/enums/page-keys.enum';
import { FlowId, type CheckinWorkflow } from '../workflow-engine.types';

export enum PhotoSelfieStep {
  Take = 'Take',
}

// Success has no extra page; a failed attempt redisplays the same step to retry.
export const photoSelfieFlow: CheckinWorkflow<PhotoSelfieStep> = {
  id: FlowId.PhotoSelfie,
  entry: PhotoSelfieStep.Take,
  steps: {
    [PhotoSelfieStep.Take]: {
      id: PhotoSelfieStep.Take,
      page: PageKey.PHOTO_FACE,
      next: (variables) =>
        variables.isSelfiePictureSuccess ? { complete: true } : { nextStep: PhotoSelfieStep.Take },
    },
  },
};
